import { useMemo } from 'react';

export const useFilterConfig = () => {
  const camposParaFiltrarPessoaFisica = useMemo(() => [
    'Data de nascimento',
    'CNPJ',
    '[Geral] Razão social',
    'CEP de entrega',
    '[Geral] Data de nascimento',
    '[Geral] Idade',
    '[Geral] Cognome',
    '[Geral] ERP',
    'CEP de cobrança',
    '[Geral] Bairro de cobrança',
    '[Geral] Complemento de cobrança',
    '[Geral] Cidade de entrega',
    '[Geral] Estado de entrega',
    '[Geral] Bairro de entrega',
    '[Geral] Endereço de entrega',
    'Outro telefone',
    'Attachment Library Field',
    'Data de nascimento',
    'Procurador',
    'Complemento',
    'Numero'
  ], []);

  const camposParaFiltrarPessoaJuridica = useMemo(() => [
    'Data de nascimento',
    'Idade',
    'CPF',
    '[Geral] Data de nascimento',
    '[Geral] Idade',
    '[Geral] Cidade de cobrança',
    '[Geral] Estado de cobrança',
    '[Geral] Cidade de entrega',
    '[Geral] Estado de entrega',
    '[Geral] ERP',
    'CEP de cobrança',
    '[Geral] Bairro de cobrança',
    '[Geral] Complemento de cobrança',
    '[Geral] Cidade de entrega',
    '[Geral] Estado de entrega',
    '[Geral] Bairro de entrega',
    '[Geral] Endereço de entrega',
    'CEP de entrega',
    'Outro telefone',
    'Attachment Library Field',
    'Data de nascimento',
    'Procurador',
    'Complemento',
    'Numero'
  ], []);

  const camposParaFiltrarTransportadora = useMemo(() => [
    'Data de nascimento',
    'Idade',
    'CPF',
    'Tipo de conta',
    '[Geral] Data de nascimento',
    '[Geral] Idade',
    '[Geral] Cidade de cobrança',
    '[Geral] Estado de cobrança',
    '[Geral] Complemento de cobrança',
    'CEP de cobrança',
    '[Geral] Endereço de cobrança',
    '[Geral] Bairro de cobrança',
    '[Geral] Cidade de entrega',
    '[Geral] Estado de entrega',
    '[Geral] Endereço de entrega',
    '[Geral] Bairro de entrega',
    '[Geral] Possui WhatsApp',
    '[Geral] Cognome',
    '[Geral] ERP',
    'CEP de entrega',
    'Outro telefone',
    'Attachment Library Field',
    'Data de nascimento',
    'Procurador',
    'Complemento',
    'Numero',
  ], []);

  const camposParaFiltrarPosto = useMemo(() => [
    'CPF',
    'Tipo de Prioridade',
    'Idade',
    'Tipo de conta',
    '[Geral] Data de nascimento',
    '[Geral] Idade',
    '[Geral] Cidade de entrega',
    '[Geral] Estado de entrega',
    '[Geral] Possui WhatsApp',
    '[Geral] Endereço de entrega',
    '[Geral] Bairro de entrega',
    '[Geral] Complemento de entrega',
    '[Geral] Bairro de cobrança',
    'CEP de entrega',
    '[Geral] Cognome',
    'CEP de cobrança',
    '[Geral] ERP',
    '[Geral] Complemento de cobrança',
    'Outro telefone',
    'Attachment Library Field',
    'Data de nascimento',
    'Procurador',
    'Complemento',
    'Numero',
  ], []);

  const camposParaFiltrarProcon = useMemo(() => [
    'Idade',
    'CPF',
    'Tipo de conta',
    '[Geral] Data de nascimento',
    '[Geral] Idade',
    '[Geral] Bairro de cobrança',
    '[Geral] Cidade de entrega',
    '[Geral] Estado de entrega',
    '[Geral] Possui WhatsApp',
    'CEP de entrega',
    '[Geral] Cognome',
    '[Geral] Complemento de cobrança',
    '[Geral] Bairro de entrega',
    '[Geral] Endereço de entrega',
    'Outro telefone',
    'Attachment Library Field',
    'Data de nascimento',
    'Procurador',
    'Complemento',
    'Numero',
  ], []);

    const camposParaFiltrarRevenda = useMemo(() => [
    'Idade',
    'CPF',
    'Tipo de conta',
    '[Geral] Data de nascimento',
    '[Geral] Idade',
    '[Geral] Bairro de cobrança',
    '[Geral] Cidade de entrega',
    '[Geral] Estado de entrega',
    '[Geral] Possui WhatsApp',
    'CEP de entrega',
    '[Geral] Cognome',
    '[Geral] Complemento de cobrança',
    '[Geral] Bairro de entrega',
    '[Geral] Endereço de entrega',
    '[Geral] ERP',
    'Outro telefone',
    'Attachment Library Field',
    'Data de nascimento',
    'Procurador',
    'Complemento',
    'Numero',
  ], []);

  const camposParaFiltrarAdvogado = useMemo(() => [
    '[Geral] Razão social',
    'Tipo de conta',
    'Idade',
    '[Geral] Data de nascimento',
    '[Geral] Idade',
    '[Geral] Possui WhatsApp',
    '[Geral] Bairro de entrega',
    '[Geral] Complemento de entrega',
    '[Geral] Endereço de entrega',
    '[Geral] ERP',
    '[Geral] Cognome',
    'CEP de entrega',
    'CNPJ',
    'CEP de cobrança',
    '[Geral] Bairro de cobrança',
    '[Geral] Complemento de cobrança',
    '[Geral] Cidade de entrega',
    '[Geral] Estado de entrega',
    'Outro telefone',
    'Attachment Library Field',
    'Data de nascimento',
    'Procurador',
    'Complemento',
    'Numero',
  ], []);

  const camposSempreExcluir = useMemo(() => [
    'Outro telefone',
    'Attachment Library Field',
    'Data de nascimento',
    'Procurador',
    'Complemento',
    'Numero',
    'IG'
  ], []);

  return {
    camposParaFiltrarPessoaFisica,
    camposParaFiltrarPessoaJuridica,
    camposParaFiltrarTransportadora,
    camposParaFiltrarPosto,
    camposParaFiltrarProcon,
    camposParaFiltrarAdvogado,
    camposParaFiltrarRevenda,
    camposSempreExcluir
  }
}